import { render, staticRenderFns } from "./AssetPoolDistribution.vue?vue&type=template&id=5c9cfbf0"
import script from "./AssetPoolDistribution.vue?vue&type=script&lang=js"
export * from "./AssetPoolDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports